<template lang="">
  <div class="bbs_filter">
    <div class="lft_area">
      <div class="bbs_info">
        <div class="total"><strong>{{ getCurrentCount() }}</strong> / {{ partnerListCount }}</div>
      </div>
    </div>
    <div class="rgt_area">
      <div class="bbs_srch">
        <select name="" id="" class="i_sel" v-model="searchType">
          <option
            v-for="option in searchOptions"
            :value="option.value"
          >{{ option.name }}</option>
        </select>
        <input type="text" class="i_txt" name="keyword" v-model="searchWord">
        <button type="button" class="bt_base gray btn_srch" @click="getSearch">검색</button>
      </div>
    </div>
  </div>

  <div class="bbs_list">
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:90px">
        <col style="width:30px">
        <col style="width:auto">
      </colgroup>
      <thead>
        <tr>
          <th scope="col">
            <span class="ui_chkbox primary nontxt">
              <input 
                type="checkbox"
                @change="toggleAllCheck($event.target.checked)"
              >
              <label for=""></label>
            </span>
          </th>
          <th scope="col">번호</th>
          <th scope="col">기관명</th>
          <th scope="col" width="80px">종류</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(partner, index) in partnerList"
        >
          <td>
            <span class="ui_chkbox primary nontxt">
              <input 
                type="checkbox"
                :value="partner.partnerSeq"
                v-model="selectedPartners"
              >
              <label for=""></label>
            </span>
          </td>
          <td>{{ index + 1 }}</td>
          <td class="content"><a @click="toPartner(partner.partnerSeq)">{{ partner.name }}</a></td>
          <td>{{ partner.type == 'funeral' ? '장례식장' : '결혼식장' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="paginate">
    <AdminPagination
      :totalPages = "totalPages()"
      :currentPage = "currentPage"
      @changePage = "changePage"
    />

    <div class="rgt_area">
      <button type="button" class="bt_base primary large_h" @click="createPartner">제휴기관 등록</button>
      <button type="button" class="bt_base gray large_h" @click="deleteSelectedPartners">삭제</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AdminPagination from '@/components/common/AdminPagination.vue';

const adminPartnerModule = 'adminPartnerModule'

export default {
  components: {
    AdminPagination
  },

  data () {
    return {
      currentPage: 1,
      selectedPartners: [],

      searchOptions: [
        { name: '전체', value: 'all' },
        { name: '기관명', value: 'none' },
      ],
      searchType: 'all',
      searchWord: ''
    }
  },
  methods: {
    ...mapActions(adminPartnerModule, [
      'requestPartnerList',
      'requestDeletePartners',
    ]),

    toPartner (partnerSeq) {
      this.$router.push({ name: "PartnerManageCreatePage", query: { partnerSeq } })
    },

    createPartner () {
      this.$router.push({ name: "PartnerManageCreatePage" })
    },

    totalPages() {
      return Math.ceil(this.partnerListCount / 10);
    },

    async changePage(page) {
      this.currentPage = page
      const {currentPage, searchType, searchWord} = this
      await this.requestPartnerList({currentPage, searchType, searchWord})
    },

    getCurrentCount() {
      const currentFirstCount = (this.currentPage - 1) * 10 + 1
      let currentLastCount = this.currentPage * 10
      if (parseInt(currentLastCount) > parseInt(this.partnerListCount)) {
        currentLastCount = this.partnerListCount
      }
      return currentFirstCount + '-' + currentLastCount
    },

    toggleAllCheck(isChecked) {
      if (isChecked) {
        this.selectedPartners = []
        for (const partner of this.partnerList) {
          this.selectedPartners.push(partner.partnerSeq)
        }
      } else {
        this.selectedPartners = []
      }
    },

    async deleteSelectedPartners() {
      if (this.selectedPartners.length === 0) {
        alert('선택된 기관이 없습니다');
        return;
      }

      const { searchType, searchWord, currentPage } = this;
      const fetchPartners = async (page = 1, type = searchType, word = searchWord, isReset = false) => {
        const params = { currentPage: page, searchType: type, searchWord: word };
        await this.requestPartnerList(params);
        if (isReset) {
          this.searchType = 'none';
        }
      };

      await this.requestDeletePartners(this.selectedPartners);
      this.selectedPartners = [];

      await fetchPartners(currentPage);

      if (this.partnerList.length === 0 && this.currentPage > 1) {
        this.currentPage -= 1;
        await fetchPartners(this.currentPage);
      }

      if (this.partnerList.length === 0 || this.currentPage === 1) {
        this.currentPage = 1;
        this.searchType = '';
        this.searchWord = '';
        await fetchPartners(1, '', '', true);
      }
    },

    async getSearch() {
      if (this.searchWord === '') {
        alert('검색어를 입력해주세요')
        return
      }
      this.currentPage = 1
      const {currentPage, searchType, searchWord} = this
      await this.requestPartnerList({currentPage, searchType, searchWord})
    }
  },

  computed: {
    ...mapState(adminPartnerModule, [
      'partnerList',
      'partnerListCount'
    ])
  },

  async mounted() {
    const {currentPage, searchType, searchWord} = this
    await this.requestPartnerList({ currentPage, searchType, searchWord })
  }
}
</script>
<style lang="">
    
</style>